import React, { useEffect, useState } from 'react'
import { WithdrawalsUserListPresenter } from './withdrawals-user-list-presenter'
import { useNavigate, useParams } from 'react-router-dom'
import {
  Opportunity,
  WithdrawalRequestStatus,
  WithdrawalSearchParamsV1,
  WithdrawRequest,
} from '../../lib/types'
import { opportunityServices, withdrawalServices } from '../../services'

const WithdrawalsUserListContainer = () => {
  const navigate = useNavigate()
  const { projectId } = useParams()
  const [opportunity, setOpportunity] = useState<Opportunity>({} as Opportunity)
  const [withdrawals, setWithdrawals] = useState<WithdrawRequest[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalWithdrawnAmount, setTotalWithdrawnAmount] = useState(0)
  const [completedWithdrawalsCount, setCompletedWithdrawalsCount] = useState(0)
  const [searchParams, setSearchParams] = useState<WithdrawalSearchParamsV1>({
    limit: '10',
    offset: '0',
    search: '',
    filter: '',
    sort: '',
    opportunity_id: projectId,
  })
  const [pagination, setPagination] = useState({
    total: 0,
    limit: 10,
    count: 5,
    offset: 0,
  })

  // Fetch opportunity information
  useEffect(() => {
    if (projectId) {
      opportunityServices.getOpportunityById(projectId, false).then((response) => {
        if (response.status === 200) {
          setOpportunity(response.data)
        }
      })
    }
  }, [projectId])

  // Fetch withdrawal request list
  useEffect(() => {
    const fetchAllWithdrawals = async () => {
      const data = await withdrawalServices.getWithdrawals(searchParams)
      if (data.status === 200) {
        setWithdrawals(data.withdrawals)
        setPagination(data.pagination)
      }
    }

    const fetchOpportunityWithdrawalStats = async () => {
      const data = await withdrawalServices.getWithdrawals({
        limit: '1000',
        offset: '0',
        opportunity_id: projectId,
        status: WithdrawalRequestStatus.TRADE_EXECUTED,
      })
      if (data.status === 200) {
        setCompletedWithdrawalsCount(data.withdrawals.length)
        setTotalWithdrawnAmount(data.totalWithdrawnAmount)
      }
    }

    fetchAllWithdrawals()
    fetchOpportunityWithdrawalStats()
  }, [currentPage, searchParams])

  const handleSearchParams = async ({ name, value }: { name: string; value: string }) => {
    const { limit } = pagination
    setSearchParams({
      ...searchParams,
      offset: '0',
      limit: limit.toString(),
      [name]: value,
    })
    setCurrentPage(1)
    setPagination({ ...pagination, offset: 0 })
  }

  const resetSearchParams = async () => {
    setSearchParams({
      limit: '10',
      offset: '0',
      search: '',
      filter: '',
      sort: '',
      opportunity_id: projectId,
    })
  }

  const handleCurrentPage = (currentPage: number) => {
    const { limit } = pagination
    setCurrentPage(currentPage)
    setSearchParams({
      ...searchParams,
      offset: `${(currentPage - 1) * limit}`,
    })
    setPagination({ ...pagination, offset: (currentPage - 1) * limit })
  }

  const handleInvestorClick = (investorId: number) => {
    navigate(`/client/${investorId}/profile`)
  }

  return (
    <WithdrawalsUserListPresenter
      opportunity={opportunity}
      withdrawals={withdrawals}
      totalWithdrawnAmount={totalWithdrawnAmount}
      completedWithdrawalsCount={completedWithdrawalsCount}
      searchParams={searchParams}
      currentPage={currentPage}
      pagination={pagination}
      handleCurrentPage={handleCurrentPage}
      handleSearchParams={handleSearchParams}
      handleInvestorClick={handleInvestorClick}
      resetSearchParams={resetSearchParams}
    />
  )
}

export { WithdrawalsUserListContainer }
